/**
 * Beta Config Hook (BL-022)
 *
 * Server-driven beta state for all three portals: banner + feedback CTA
 * (`beta.enabled`) and the discount pricing mode. The endpoint is
 * PUBLIC, so the query runs without auth — the banner can show on
 * pre-login screens and the state survives sign-out.
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../providers/SdkProvider';
import { BetaConfigService, type BetaConfig } from '../services/beta-config.service';

export const betaConfigKeys = {
  all: ['betaConfig'] as const,
  config: () => [...betaConfigKeys.all, 'config'] as const,
};

export function useBetaConfig() {
  const client = useApiClient();
  const service = new BetaConfigService(client);

  return useQuery<BetaConfig, Error>({
    queryKey: betaConfigKeys.config(),
    queryFn: () => service.getBetaConfig(),
    // Effectively boot-time config: refetch only on a fresh session.
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}
